import React from 'react';
import { ArrowRight, Repeat } from 'lucide-react';

export type JourneyType = 'ONE_WAY' | 'ROUND_TRIP_SAME_DAY';

interface BookingModeSelectorProps {
  selectedJourney: JourneyType;
  onChange: (journey: JourneyType) => void;
  disabled?: boolean;
}

export const BookingModeSelector: React.FC<BookingModeSelectorProps> = ({
  selectedJourney,
  onChange,
  disabled = false,
}) => {
  const options: Array<{
    id: JourneyType;
    label: string;
    sublabel: string;
    badge?: string;
    icon: React.ReactNode;
  }> = [
    {
      id: 'ONE_WAY',
      label: 'ذهاب فقط',
      sublabel: 'السفر من الإسكندرية إلى الجامعة فقط',
      badge: 'سفر فردي',
      icon: <ArrowRight size={20} />,
    },
    {
      id: 'ROUND_TRIP_SAME_DAY',
      label: 'ذهاب وعودة في نفس اليوم',
      sublabel: 'السفر صباحاً والعودة بعد المحاضرات في نفس اليوم',
      badge: 'الخيار الأوفر والمضمون',
      icon: <Repeat size={20} />,
    },
  ];

  return (
    <div className="booking-mode-container" dir="rtl">
      <div className="booking-mode-header-label">
        <span className="text-sm font-bold text-slate-800">1. اختر نوع الرحلة:</span>
        <span className="text-xs text-slate-500">حدد ما إذا كنت ترغب في الذهاب فقط أو الذهاب والعودة في نفس اليوم</span>
      </div>

      <div className="booking-mode-grid two-columns" role="radiogroup" aria-label="نوع الرحلة">
        {options.map((opt) => {
          const isSelected = selectedJourney === opt.id;
          return (
            <button
              key={opt.id}
              type="button"
              role="radio"
              aria-checked={isSelected}
              disabled={disabled}
              onClick={() => onChange(opt.id)}
              className={`booking-mode-card ${isSelected ? 'selected' : ''}`}
            >
              {opt.badge && <span className="mode-pill-badge">{opt.badge}</span>}
              <div className="mode-card-icon-wrap">{opt.icon}</div>
              <div className="mode-card-text">
                <strong className="mode-card-title">{opt.label}</strong>
                <span className="mode-card-sub">{opt.sublabel}</span>
              </div>
              <div className="mode-check-circle" aria-hidden="true">
                <span className="check-dot"></span>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};
